module.exports = __webpack_public_path__ + "img/kg.1270b7a4.svg";